import {
  Collection1k04j3hzsbod0 as Collection,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  VOID7hggqo3abtya as VOID,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  HashMap1a0ld5kgwhmhv as HashMap,
  toMutableList20rdgwi7d3cwi as toMutableList,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  Unit_instanceat14thlj150z as Unit_instance,
  toMutableMapr5f3w62lv8sk as toMutableMap,
  toMutableSetjdpdbr9jsqq8 as toMutableSet,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  KtMap140uvy3s5zad8 as KtMap,
  isInterface3d6p8outrmvmk as isInterface,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  addAll21mdhg523wnoa as addAll,
  KtMutableList1beimitadwkna as KtMutableList,
  AbstractList3ck35puwbp1e9 as AbstractList,
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  AbstractMutableList192xfq8ycgofs as AbstractMutableList,
  copyToArray2j022khrow2yi as copyToArray,
  get_lastIndex1yw0x4k50k51w as get_lastIndex,
  joinToStringxqcavsxcmh4q as joinToString,
  protoOf180f3jzyo7rfj as protoOf,
  RandomAccess1jbw8sdogqb8x as RandomAccess,
} from './kotlin-kotlin-stdlib.mjs';
import { get_atomicfu$reentrantLock3o926yhldwf1 as get_atomicfu$reentrantLock } from './kotlinx-atomicfu.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class DoubleList {}
function getAt(index) {
  return this.d1(index);
}
function toDoubleArray() {
  var tmp = 0;
  var tmp_0 = this.e1();
  var tmp_1 = new Float64Array(tmp_0);
  while (tmp < tmp_0) {
    var tmp_2 = tmp;
    tmp_1[tmp_2] = this.d1(tmp_2);
    tmp = tmp + 1 | 0;
  }
  return tmp_1;
}
function listIterator() {
  return this.d3(0);
}
function listIterator_0(index) {
  return this.e3(index, this.e1()).c3();
}
function subList(fromIndex, toIndex) {
  return SimpleSubList(fromIndex, toIndex, DoubleList$subList$lambda(this));
}
function containsAll(elements) {
  return containsAllCheck(this, elements);
}
function isEmpty() {
  return this.e1() === 0;
}
function iterator() {
  return this.c3();
}
class Mixin {
  constructor(extra) {
    extra = extra === VOID ? null : extra;
    this.q10_1 = extra;
  }
  r10(_set____db54di) {
    this.q10_1 = _set____db54di;
  }
  s10() {
    return this.q10_1;
  }
}
class Property {
  constructor(name, defaultGen) {
    name = name === VOID ? null : name;
    this.t10_1 = name;
    this.u10_1 = defaultGen;
  }
}
class PropertyThis {
  constructor(name, defaultGen) {
    name = name === VOID ? null : name;
    this.v10_1 = name;
    this.w10_1 = defaultGen;
    var tmp = this;
    tmp.x10_1 = Extra$PropertyThis$transform$lambda;
  }
}
class ExtraObject {
  constructor() {
    var tmp = this;
    // Inline function 'kotlinx.atomicfu.locks.reentrantLock' call
    tmp.y10_1 = get_atomicfu$reentrantLock();
    this.z10_1 = HashMap.y8();
    var tmp_0 = this;
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.y10_1;
    // Inline function 'korlibs.datastructure.ExtraObject.values.<anonymous>' call
    tmp_0.a11_1 = toMutableList(this.z10_1.n3());
  }
  e1() {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.y10_1;
    // Inline function 'korlibs.datastructure.ExtraObject.<get-size>.<anonymous>' call
    return this.z10_1.e1();
  }
  s1() {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.y10_1;
    // Inline function 'korlibs.datastructure.ExtraObject.<get-entries>.<anonymous>' call
    // Inline function 'kotlin.collections.associateWith' call
    var this_0 = this.z10_1.i3();
    var result = LinkedHashMap.sc(coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16));
    // Inline function 'kotlin.collections.associateWithTo' call
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.datastructure.ExtraObject.<get-entries>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = this.z10_1.h3(element);
      result.j3(element, tmp$ret$0);
    }
    return toMutableSet(toMutableMap(result).s1());
  }
  i3() {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.y10_1;
    // Inline function 'korlibs.datastructure.ExtraObject.<get-keys>.<anonymous>' call
    return toMutableSet(this.z10_1.i3());
  }
  n3() {
    return this.a11_1;
  }
  oi(key) {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.y10_1;
    // Inline function 'korlibs.datastructure.ExtraObject.get.<anonymous>' call
    return this.z10_1.h3(key);
  }
  h3(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.oi((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
  b11(key, value) {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.y10_1;
    this.z10_1.j3(key, value);
    return Unit_instance;
  }
  c11(key) {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.y10_1;
    // Inline function 'korlibs.datastructure.ExtraObject.contains.<anonymous>' call
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_0 = this.z10_1;
    return (isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).f3(key);
  }
  g1() {
    return this.e1() === 0;
  }
  m3() {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.y10_1;
    this.z10_1.m3();
    return Unit_instance;
  }
  d11(key) {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.y10_1;
    // Inline function 'korlibs.datastructure.ExtraObject.remove.<anonymous>' call
    return this.z10_1.k3(key);
  }
  k3(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.d11((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
  e11(key, value) {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.y10_1;
    this.z10_1.j3(key, value);
    return Unit_instance;
  }
  j3(key, value) {
    var tmp = (!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE();
    return this.e11(tmp, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  }
  f11(key) {
    // Inline function 'korlibs.datastructure.ExtraObject.lock' call
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.y10_1;
    // Inline function 'korlibs.datastructure.ExtraObject.containsKey.<anonymous>' call
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_0 = this.z10_1;
    return (isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).f3(key);
  }
  f3(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    return this.f11((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
}
class MutableListEx {}
function setAddAll(index, elements, offset, size) {
  // Inline function 'kotlin.math.min' call
  var b = this.e1() - index | 0;
  var setCount = Math.min(size, b);
  this.o11(index, elements, offset, setCount);
  this.p11(elements, offset + setCount | 0, size - setCount | 0);
}
function setAddAll$default(index, elements, offset, size, $super) {
  offset = offset === VOID ? 0 : offset;
  size = size === VOID ? elements.e1() - offset | 0 : size;
  var tmp;
  if ($super === VOID) {
    this.n11(index, elements, offset, size);
    tmp = Unit_instance;
  } else {
    setAddAll(index, elements, offset, size);
    tmp = Unit_instance;
  }
  return tmp;
}
function setAll(index, elements, offset, size) {
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      this.p3(index + n | 0, elements.d1(offset + n | 0));
    }
     while (inductionVariable < size);
}
function addAll_0(elements, offset, size) {
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      this.h(elements.d1(offset + n | 0));
    }
     while (inductionVariable < size);
}
function removeToSize(size) {
  this.m11(size, this.e1());
}
class SimpleSubList$1 extends AbstractList {
  static t11($toIndex, $fromIndex, $get, $box) {
    if ($box === VOID)
      $box = {};
    $box.q11_1 = $toIndex;
    $box.r11_1 = $fromIndex;
    $box.s11_1 = $get;
    return this.ej($box);
  }
  e1() {
    return this.q11_1 - this.r11_1 | 0;
  }
  d1(index) {
    if (!(0 <= index ? index < this.e1() : false))
      throw IndexOutOfBoundsException.pe();
    return this.s11_1(index + this.r11_1 | 0);
  }
}
class Fixed {
  constructor(value) {
    this.u11_1 = value;
  }
  v11() {
    return this.u11_1;
  }
  toString() {
    return 'Fixed(value=' + toString(this.u11_1) + ')';
  }
  hashCode() {
    return hashCode(this.u11_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Fixed))
      return false;
    var tmp0_other_with_cast = other instanceof Fixed ? other : THROW_CCE();
    if (!equals(this.u11_1, tmp0_other_with_cast.u11_1))
      return false;
    return true;
  }
}
class FastArrayList extends AbstractMutableList {
  static w11(__array) {
    var $this = this.n7();
    $this.h11_1 = __array;
    return $this;
  }
  static j11() {
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    return this.w11(tmp$ret$0);
  }
  static i11(initialCapacity) {
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    return this.w11(tmp$ret$0);
  }
  e1() {
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.h11_1.length;
  }
  d1(index) {
    // Inline function 'korlibs.datastructure.get' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.h11_1[rangeCheck(this, index)];
  }
  p3(index, element) {
    rangeCheck(this, index);
    // Inline function 'kotlin.apply' call
    // Inline function 'korlibs.datastructure.get' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.asDynamic' call
    var this_0 = this.h11_1[index];
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.FastArrayList.set.<anonymous>' call
    // Inline function 'korlibs.datastructure.set' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.asDynamic' call
    this.h11_1[index] = element;
    return this_0;
  }
  h(element) {
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    this.h11_1.push(element);
    this.c7_1 = this.c7_1 + 1 | 0;
    return true;
  }
  q3(index, element) {
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    this.h11_1.splice(insertionRangeCheck(this, index), 0, element);
    this.c7_1 = this.c7_1 + 1 | 0;
  }
  f1(elements) {
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$0 = copyToArray(elements);
    return _addAll(this, tmp$ret$0);
  }
  r3(index) {
    rangeCheck(this, index);
    this.c7_1 = this.c7_1 + 1 | 0;
    var tmp;
    if (index === 0) {
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = this.h11_1.shift();
    } else if (index === get_lastIndex(this)) {
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = this.h11_1.pop();
    } else {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = this.h11_1.splice(index, 1)[0];
    }
    return tmp;
  }
  o3(element) {
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.h11_1;
    var inductionVariable = 0;
    var last = array.length;
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.datastructure.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$4 = array[index];
        if (equals(tmp$ret$4, element)) {
          array.splice(index, 1);
          this.c7_1 = this.c7_1 + 1 | 0;
          return true;
        }
      }
       while (inductionVariable < last);
    return false;
  }
  m11(fromIndex, toIndex) {
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    this.h11_1.splice(fromIndex, toIndex - fromIndex | 0);
    this.c7_1 = this.c7_1 + 1 | 0;
  }
  m3() {
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    this.h11_1.length = 0;
    this.c7_1 = this.c7_1 + 1 | 0;
  }
  b3(element) {
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.h11_1.indexOf(element);
  }
  toString() {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$4 = this.h11_1;
    return '[' + joinToString(tmp$ret$4, ', ') + ']';
  }
  m8() {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.h11_1.concat();
  }
  toArray() {
    return this.m8();
  }
}
//endregion
function DoubleList$subList$lambda(this$0) {
  return function (it) {
    return this$0.d1(it);
  };
}
function Extra$PropertyThis$transform$lambda(_this__u8e3s4, it) {
  return it;
}
function getExtra(_this__u8e3s4, name) {
  var tmp3_safe_receiver = _this__u8e3s4.s10();
  return tmp3_safe_receiver == null ? null : tmp3_safe_receiver.oi(name);
}
function setExtra(_this__u8e3s4, name, value) {
  if (_this__u8e3s4.s10() == null) {
    if (value == null)
      return Unit_instance;
    _this__u8e3s4.r10(ExtraTypeCreate());
  }
  var tmp4_safe_receiver = _this__u8e3s4.s10();
  if (tmp4_safe_receiver == null)
    null;
  else {
    tmp4_safe_receiver.b11(name, value);
  }
}
function hasExtra(_this__u8e3s4, name) {
  var tmp2_safe_receiver = _this__u8e3s4.s10();
  return (tmp2_safe_receiver == null ? null : tmp2_safe_receiver.c11(name)) === true;
}
function getExtraTyped(_this__u8e3s4, name) {
  var tmp = _this__u8e3s4.s10();
  var tmp1_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
  return tmp1_safe_receiver == null ? null : tmp1_safe_receiver.h3(name);
}
function ExtraTypeCreate() {
  return new ExtraObject();
}
function fastArrayListOf(values) {
  // Inline function 'kotlin.also' call
  var this_0 = FastArrayList.i11(values.length);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.fastArrayListOf.<anonymous>' call
  addAll(this_0, values);
  return this_0;
}
function toFastList(_this__u8e3s4) {
  // Inline function 'kotlin.also' call
  var this_0 = FastArrayList.i11(_this__u8e3s4.length);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.datastructure.toFastList.<anonymous>' call
  // Inline function 'korlibs.datastructure.fastForEach' call
  var n = 0;
  while (n < _this__u8e3s4.length) {
    // Inline function 'korlibs.datastructure.toFastList.<anonymous>.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var it = _this__u8e3s4[_unary__edvuaz];
    this_0.h(it);
  }
  return this_0;
}
function toFastList_0(_this__u8e3s4, out) {
  out = out === VOID ? FastArrayList.j11() : out;
  out.k11(0, _this__u8e3s4);
  out.l11(_this__u8e3s4.e1());
  return out;
}
function SimpleSubList(fromIndex, toIndex, get) {
  return SimpleSubList$1.t11(toIndex, fromIndex, get);
}
function containsAllCheck(collection, elements) {
  var elementsMap = toMutableSet(elements);
  var _iterator__ex2g4s = collection.a1();
  while (_iterator__ex2g4s.b1()) {
    var v = _iterator__ex2g4s.c1();
    elementsMap.o3(v);
  }
  return elementsMap.g1();
}
function Resourceable(value) {
  return new Fixed(value);
}
function _addAll($this, elements) {
  // Inline function 'kotlin.collections.isEmpty' call
  if (elements.length === 0)
    return false;
  // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$3 = $this.h11_1;
  (function () {
    var $externalVarargReceiverTmp = tmp$ret$3;
    return $externalVarargReceiverTmp.push.apply($externalVarargReceiverTmp, [].slice.call(elements.slice()));
  }.call(this));
  $this.c7_1 = $this.c7_1 + 1 | 0;
  return true;
}
function rangeCheck($this, index) {
  if (index < 0 || index >= $this.e1())
    throw IndexOutOfBoundsException.q1('index: ' + index + ', size: ' + $this.e1());
  return index;
}
function insertionRangeCheck($this, index) {
  if (index < 0 || index > $this.e1())
    throw IndexOutOfBoundsException.q1('index: ' + index + ', size: ' + $this.e1());
  return index;
}
//region block: post-declaration
initMetadataForInterface(DoubleList, 'DoubleList', VOID, VOID, [Collection]);
initMetadataForClass(Mixin, 'Mixin', Mixin);
initMetadataForClass(Property, 'Property');
initMetadataForClass(PropertyThis, 'PropertyThis');
initMetadataForClass(ExtraObject, 'ExtraObject', ExtraObject, VOID, [KtMutableMap]);
initMetadataForInterface(MutableListEx, 'MutableListEx', VOID, VOID, [KtMutableList]);
initMetadataForClass(SimpleSubList$1);
initMetadataForClass(Fixed, 'Fixed', VOID, VOID, VOID, [0]);
protoOf(FastArrayList).p11 = addAll_0;
protoOf(FastArrayList).n11 = setAddAll;
protoOf(FastArrayList).k11 = setAddAll$default;
protoOf(FastArrayList).o11 = setAll;
protoOf(FastArrayList).l11 = removeToSize;
initMetadataForClass(FastArrayList, 'FastArrayList', FastArrayList.j11, VOID, [AbstractMutableList, MutableListEx, RandomAccess]);
//endregion
//region block: exports
export {
  containsAll as containsAll1oa5i6t9xmbdv,
  getAt as getAt237u54ctbxwvd,
  isEmpty as isEmptyrqh4vz39e0v6,
  iterator as iterator300ls4j24zqzz,
  listIterator as listIterator247sl90ooi4qv,
  listIterator_0 as listIterator1a2ckgeamf7jc,
  subList as subList28p829u9d5w23,
  DoubleList as DoubleList2honu8rif2roh,
  Mixin as Mixin3lmkm5hum2vdj,
  PropertyThis as PropertyThis2r0hbk1cs09wj,
  Property as Property1m5vulkepgwzd,
  FastArrayList as FastArrayListw5fr1wlp4slq,
  fastArrayListOf as fastArrayListOf1rdodhrpn0q8y,
  getExtraTyped as getExtraTyped8zexqxz5xxli,
  getExtra as getExtra307y0o9pd6mp3,
  hasExtra as hasExtra1969mplo13qgb,
  setExtra as setExtra314k0z6q35eku,
  toFastList_0 as toFastList1btvvxvv57pw,
  toFastList as toFastListzo2jtkrx0z5y,
  Resourceable as Resourceable38whwgli3ts8g,
};
//endregion
